import { momentFecha } from "../../utils/funciones";
import PropTypes from "prop-types";

export const CardDatosLaborales = ({ datosLaborales }) => {
  const { fecha_retiro, codigo_sap, nombre_vacante, tipo_contrato, temporis_unidad_rol, inicio_solicitud, fecha_ingreso, temporis_plan_horario, nombre_local } = datosLaborales;

  return (
    <div className="card my-3 px-0">
      <div className="card-header bgArcopime">
        <span className="h6 my-0">Datos laborales</span>
      </div>
      <div className="card-body">
        <div className="row">
          <p className="col-4 mb-1">
            <span className="tagLabel">Cargo a Ocupar:</span> {`${codigo_sap}  ${nombre_vacante}`}
          </p>
          <p className="col-4 mb-1">
            <span className="tagLabel me-1">Tipo contrato:</span>
            {(tipo_contrato === 1 && "Plazo Fijo 30 Días") || (tipo_contrato === 2 && "Plazo Fijo 60 Días") || (tipo_contrato === 3 && "Plazo Fijo 90 Días") || (tipo_contrato === 4 && "Indefinido")}
          </p>
          <p className="col-4 mb-1">
            <span className="tagLabel">Unidad de temporis:</span> {temporis_unidad_rol.data !== "" ? JSON.parse(temporis_unidad_rol.data).Unidadorganizativa : "No aplica"}
          </p>
        </div>
        <div className="row">
          <p className="col-4 mb-1">
            <span className="tagLabel">Inicio solicitud:</span> {inicio_solicitud}
          </p>
          <p className="col-4 mb-1">
            <span className="tagLabel">Ingreso:</span> {momentFecha(fecha_ingreso)}
          </p>
          <p className="col-4 mb-1">
            <span className="tagLabel me-1">Término:</span>
            {tipo_contrato !== 4 ? momentFecha(fecha_retiro) : "Plazo indefinido"}
          </p>
        </div>
        <div className="row">
          <p className="col-4 mb-1">
            <span className="tagLabel">Horario de temporis:</span> {temporis_plan_horario}
          </p>
          <p className="col-8 mb-1">
            <span className="tagLabel me-1">Nombre local:</span>
            {nombre_local || "No aplica"}
          </p>
        </div>
      </div>
    </div>
  );
};

CardDatosLaborales.propTypes = {
  datosLaborales: PropTypes.shape({
    fecha_retiro: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    codigo_sap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nombre_vacante: PropTypes.string,
    tipo_contrato: PropTypes.number,
    temporis_unidad_rol: PropTypes.shape({
      data: PropTypes.string,
    }),
    inicio_solicitud: PropTypes.string,
    fecha_ingreso: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    temporis_plan_horario: PropTypes.string,
    nombre_local: PropTypes.string,
  }).isRequired,
};

export const CardDatosPeronales = ({ propiedades }) => {
  const { datosPersonales, filtrarGradoEducacion, filtrarEstadoCivil, filtrarSexo, filtrarPaisPersona } = propiedades;
  const { nombre, fecha_nacimiento, correo, apellido_pat, telefono, apellido_mat, identificacion } = datosPersonales;

  return (
    <div className="card my-3 px-0">
      <div className="card-header bgArcopime">
        <span className="h6 my-0">Datos personales</span>
      </div>
      <div className="card-body">
        <div className="row">
          <p className="col-4 mb-1">
            <span className="tagLabel">Nombre:</span> <span className="text-capitalize">{nombre}</span>
          </p>
          <p className="col-4 mb-1">
            <span className="tagLabel">Fecha de nacimiento:</span> {momentFecha(fecha_nacimiento)}
          </p>
          <p className="col-4 mb-1">
            <span className="tagLabel">Email:</span> {correo}
          </p>
        </div>
        <div className="row">
          <p className="col-4 mb-1">
            <span className="tagLabel">Apellido paterno:</span> <span className="text-capitalize">{apellido_pat}</span>
          </p>
          <p className="col-4 mb-1">
            <span className="tagLabel">Grado de educación:</span> {filtrarGradoEducacion}
          </p>
          <p className="col-4 mb-1">
            <span className="tagLabel">Teléfono:</span>
            <span className="mx-1">+569</span> {telefono}
          </p>
        </div>
        <div className="row">
          <p className="col-4 mb-1">
            <span className="tagLabel">Apellido materno:</span> <span className="text-capitalize">{apellido_mat || "No aplica"}</span>
          </p>
          <p className="col-4 mb-1">
            <span className="tagLabel">Estado civil:</span> {filtrarEstadoCivil}
          </p>
          <p className="col-4 mb-1">
            <span className="tagLabel">Género:</span> {filtrarSexo}
          </p>
        </div>
        <div className="row">
          <p className="col-4 mb-1">
            <span className="tagLabel">Rut:</span> {identificacion}
          </p>
          <p className="col-4 mb-1">
            <span className="tagLabel">País:</span> {filtrarPaisPersona}
          </p>
        </div>
      </div>
    </div>
  );
};

CardDatosPeronales.propTypes = {
  propiedades: PropTypes.shape({
    datosPersonales: PropTypes.shape({
      nombre: PropTypes.string,
      fecha_nacimiento: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
      correo: PropTypes.string,
      apellido_pat: PropTypes.string,
      telefono: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      apellido_mat: PropTypes.string,
      identificacion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
    filtrarGradoEducacion: PropTypes.string,
    filtrarEstadoCivil: PropTypes.string,
    filtrarSexo: PropTypes.string,
    filtrarPaisPersona: PropTypes.string,
  }).isRequired,
};

export const CardDatosExtranjero = ({ propiedades }) => {
  const { datosExtranjero } = propiedades;
  const { id_persona_tipo_visa, fecha_visa_temporaria, fecha_vencimiento_visa } = datosExtranjero;

  return (
    <div className="card my-3 px-0">
      <div className="card-header bgArcopime">
        <span className="h6 my-0">Datos extranjería</span>
      </div>
      <div className="card-body">
        <div className="row">
          <p className="col-4">
            <span className="tagLabel">Tipo de visa:</span> {id_persona_tipo_visa === 1 ? "Definitiva" : "Temporaria"}
          </p>
          <p className="col-4">
            <span className="tagLabel me-1">Fecha emisión:</span>
            {momentFecha(fecha_visa_temporaria)}
          </p>
          <p className="col-4">
            <span className="tagLabel me-1">Fecha vencimiento:</span>
            {momentFecha(fecha_vencimiento_visa)}
          </p>
        </div>
      </div>
    </div>
  );
};

CardDatosExtranjero.propTypes = {
  propiedades: PropTypes.shape({
    datosExtranjero: PropTypes.shape({
      id_persona_tipo_visa: PropTypes.number,
      fecha_visa_temporaria: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
      fecha_vencimiento_visa: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    }).isRequired,
  }).isRequired,
};

export const CardDatosDireccion = ({ propiedades }) => {
  const { filtrarPaisDireccion, filtrarRegion, comunas, datosDireccion } = propiedades;
  const { direccion, numero, numero_departamento } = datosDireccion;

  return (
    <div className="col-4 ps-0">
      <div className="card my-3 px-0">
        <div className="card-header bgArcopime">
          <span className="h6 my-0">Dirección</span>
        </div>
        <div className="card-body">
          <div className="row">
            <p className="mb-1">
              <span className="tagLabel">Dirección:</span> {direccion}
            </p>
            <p className="mb-1">
              <span className="tagLabel">País:</span> {filtrarPaisDireccion}
            </p>
            <p className="mb-1">
              <span className="tagLabel">Región:</span> {filtrarRegion}
            </p>
            <p className="mb-1">
              <span className="tagLabel">Comuna:</span> {comunas}
            </p>
            <p className="mb-1">
              <span className="tagLabel">Número:</span> {numero || "No especifíca"}
            </p>
            <p className="mb-1">
              <span className="tagLabel">Casa/Depto/Parcela:</span> {numero_departamento || "No especifíca"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

CardDatosDireccion.propTypes = {
  propiedades: PropTypes.shape({
    filtrarPaisDireccion: PropTypes.string,
    filtrarRegion: PropTypes.string,
    comunas: PropTypes.string,
    datosDireccion: PropTypes.shape({
      direccion: PropTypes.string,
      numero: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      numero_departamento: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
  }).isRequired,
};

export const CardDatosPrevisionSalud = ({ propiedades }) => {
  const { filtrarAfp, datosPrevision, datoSalud } = propiedades;
  const { id, nombre, valorPlan } = datoSalud;
  const { jubilado } = datosPrevision;

  return (
    <div className="card my-3 px-0">
      <div className="card-header bgArcopime">
        <span className="h6 my-0">Datos previsión</span>
      </div>
      <div className="card-body">
        <div className="row">
          <p className="mb-1">
            <span className="tagLabel">Es una persona jubilada:</span> {jubilado === 1 ? "Si" : "No"}
          </p>
          <p className="mb-1">
            <span className="tagLabel">Afp:</span> {filtrarAfp}
          </p>
          <p className="mb-1">
            <span className="tagLabel">{id === 1 ? "Plan salud" : "Isapre"}:</span> {nombre}
          </p>
          <p className="mb-1">
            {id !== 1 && (
              <>
                <span className="tagLabel">Valor:</span> {valorPlan}
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

CardDatosPrevisionSalud.propTypes = {
  propiedades: PropTypes.shape({
    filtrarAfp: PropTypes.string,
    datosPrevision: PropTypes.shape({
      jubilado: PropTypes.number,
    }).isRequired,
    datoSalud: PropTypes.shape({
      id: PropTypes.number,
      nombre: PropTypes.string,
      valorPlan: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
  }).isRequired,
};

export const CardDatosBancarios = ({ propiedades }) => {
  const {datosBancarios } = propiedades;
  const { tipo_pago, nombre_banco, nombre_tipo_cuenta, numero_cuenta } = datosBancarios;

  return (
    <div className="card my-3 px-0">
      <div className="card-header bgArcopime">
        <span className="h6 my-0">Datos bancarios</span>
      </div>
      <div className="card-body">
        <div className="row">
          {tipo_pago === 3 ? (
            <p className="mb-1">
              <span className="tagLabel">Tipo pago:</span> Servipag
            </p>
          ) : (
            <>
              <p className="mb-1">
                <span className="tagLabel">Banco:</span> {nombre_banco}
              </p>
              <p className="mb-1">
                <span className="tagLabel">Tipo de cuenta:</span> {nombre_tipo_cuenta}
              </p>
              <p className="mb-1">
                <span className="tagLabel">Número de cuenta:</span> {numero_cuenta}
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

CardDatosBancarios.propTypes = {
  propiedades: PropTypes.shape({
    datosBancarios: PropTypes.shape({
      tipo_pago: PropTypes.number,
      nombre_banco: PropTypes.string,
      nombre_tipo_cuenta: PropTypes.string,
      numero_cuenta: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
  }).isRequired,
};

export const CardDocumentos = ({ propiedades }) => {
  const { datosDocumento } = propiedades;

  return (
    <div className="row">
      <div className="card my-3 px-0">
        <div className="card-header bgArcopime">
          <span className="h6 my-0">Documentos</span>
        </div>
        <div className="card-body">
          <div className="row">
            {datosDocumento.map((documento, indx) => (
              <div className="col-lg-3 col-sm-3" key={Number.parseInt(indx)}>
                <div className="card border-dark mb-3">
                  <div className="card-header">{documento.documento}</div>
                  <div className="card-body text-dark">
                    <a target="_blank" rel="noreferrer" href={documento.url} className="btn btn-outline-success">
                      ver documento
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

CardDocumentos.propTypes = {
  propiedades: PropTypes.shape({
    datosDocumento: PropTypes.arrayOf(
      PropTypes.shape({
        documento: PropTypes.string,
        url: PropTypes.string,
      })
    ).isRequired,
  }).isRequired,
};
